import React from 'react';
import { useSelector } from 'react-redux';
import { FaDownload } from 'react-icons/fa';
import { selectMetadataKeyByRegion } from './../../reducers/selectors/metadata';
import {
  selectUserIsLoggedIn,
  selectUserSubscriptions,
} from './label.selector';
import './labelStyle.scss';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { PROVIDER_DATA } from 'utils/homologacion/contants';

//----Uso: const { renderLabel } = useRenderChapas();----
//----renderLabel recibe un objeto con todas las propiedades del contenido----
const useRenderChapas = () => {
  const asset = useSelector(state => state.asset);
  const translations = useSelector(state => state.translations);
  const isLoggedIn = useSelector(selectUserIsLoggedIn);
  const userSubscriptions = useSelector(selectUserSubscriptions);
  const claroLiteConfig = useSelector(
    selectMetadataKeyByRegion('cv_advertising_config'),
  );
  const providersConfig = useSelector(
    selectMetadataKeyByRegion(
      claroLiteConfig?.enable
        ? 'providers_label_configuration_ads'
        : 'update_providers_label_configuration',
    ),
  );

  const getLegacyUserType = providerName => {
    if (!isLoggedIn) {
      return 'anonymous';
    }
    //----Linea 30, Fix para hacer match con picardia_nacional----
    const isSubscribed = Object.keys(userSubscriptions).find(
      sub =>
        sub?.toLocaleUpperCase() === providerName ||
        sub?.toUpperCase()?.startsWith(providerName?.replace('2', '')) ||
        sub?.toUpperCase()?.startsWith(providerName?.replace('V3', 'SPORTS')) ||
        sub?.toUpperCase() ===
          providerName.replace('RADIO_TV ESPAÑOLA', 'RTVEPLAY'),
    );

    if (isSubscribed && isLoggedIn) {
      return 'susc';
    } else if (!isSubscribed && isLoggedIn) {
      return 'no_susc';
    }
  };

  const getNewUserType = providerCode => {
    if (!isLoggedIn) {
      return 'freemium';
    }

    const isSubscribed = Object.keys(userSubscriptions).find(
      sub =>
        sub?.toUpperCase() === providerCode ||
        sub?.toUpperCase()?.startsWith(providerCode?.replace('2', '')) ||
        sub?.toUpperCase()?.startsWith(providerCode?.replace('V3', 'SPORTS')) ||
        sub?.toUpperCase() ===
          providerCode?.replace('RADIO_TV ESPAÑOLA', 'RTVEPLAY'),
    );

    if (isSubscribed && isLoggedIn) {
      return 'preemium';
    } else if (!isSubscribed && isLoggedIn) {
      return 'freemium_registrado';
    }
  };

  const getChapa = (providerName, providerCode, type, contentType) => {
    if (providerName === null || providerName === undefined) return;
    const userType = claroLiteConfig?.enable
      ? getNewUserType(providerCode?.toUpperCase())
      : getLegacyUserType(providerName?.replace(' ', '_')?.toUpperCase());
    let config = providersConfig?.[userType];
    config = config?.[providerCode] || config?.default;
    let typeconfig;
    if (
      config?.[type]?.[`${contentType}_play0`] ||
      config?.[type]?.[`${contentType}_play1`]
    ) {
      typeconfig =
        config?.[type]?.[`${contentType}_play0`] &&
        config?.[type]?.[`${contentType}_play1`];
    } else if (config?.[type] || config?.[type]?.[contentType]) {
      typeconfig = config?.[type] && config?.[type]?.[contentType];
    }

    return typeconfig;
  };

  const parseToRgb = backgroundColor => {
    let backgroundHex = backgroundColor;
    if (backgroundHex.length === 9) {
      const opacity = parseInt(backgroundHex.substring(1, 3), 16) / 255;
      backgroundHex = backgroundHex.substr(3, backgroundColor.length);
      const r = parseInt(backgroundHex.substring(0, 2), 16);
      const g = parseInt(backgroundHex.substring(2, 4), 16);
      const b = parseInt(backgroundHex.substring(4, 6), 16);

      backgroundHex = `rgba(${r},${g},${b},${opacity})`;
    }

    return backgroundHex;
  };

  const renderLabel = (item, isHighLight) => {
    const isLive = getContentListV1?.IsLive(item)
    const contentType = isLive ? 'live' : 'vod';
    const formatTypes = getContentListV1?.marketingType(item)?.split(',');

    const sheetsToShow = formatTypes.reduce((prev, type) => {
      const configChapa = getChapa(
        getContentListV1?.provider(item, PROVIDER_DATA?.NAME),
        getContentListV1?.provider(item, PROVIDER_DATA?.CODE),
        type,
        contentType,
      );

      if (!configChapa) return prev;
      return [...prev, ...configChapa];
    }, []);

    return (
      <div className="posterLabel">
        {sheetsToShow.map((sheet, index) => {
          const style = {
            float: sheet.gravity,
          };
          if (sheet.type === 'image' && sheet.url.indexOf('icon') !== -1) {
            if (sheet.url.indexOf('download') !== -1) {
              return (
                <div
                  className="posterLabel--icon"
                  key={`${item?.id}${index}`}
                  style={style}
                >
                  <FaDownload />
                </div>
              );
            }
          }
          if (sheet.url) {
            return (
              <div
                className="posterLabel--image"
                key={`${item?.id}${index}`}
                style={{
                  ...style,
                  height: isHighLight ? 'unset' : '16px',
                  marginBottom: '6px',
                }}
              >
                <img
                  src={asset[sheet.url]}
                  alt="poster"
                  style={{ width: 'auto' }}
                />
              </div>
            );
          }
          const text = translations[sheet.text];

          if (!text || text === '') {
            return <></>;
          }

          const textHex = sheet.textColor;
          const backgroundColor = parseToRgb(sheet.backgroundColor);

          return (
            <div
              className={`posterLabel--text ${sheet?.text}`}
              key={`${item.id}${index}`}
              style={{ backgroundColor, color: textHex, ...style }}
            >
              {text}
            </div>
          );
        })}
      </div>
    );
  };

  return {
    renderLabel,
  };
};

export default useRenderChapas;
